
(function () {
  'use strict';

  if (window.BramoweHomePager) return;
  window.BramoweHomePager = true;

  function Wskaznik(el) {
    this.el = el;
    this.tor = document.getElementById(el.getAttribute('data-tor') || '');
    this.etykieta = el.getAttribute('data-etykieta') || '';
    this.uchwyty = [];
    this.kreski = [];
    this.kafle = [];
    this.ramka = 0;
    this.petla = false;
    this.obserwator = null;
    this.zmiany = null;
    if (!this.tor) return;
    this.zbuduj();
    this.podlacz();
    this.odswiez();
  }

  Wskaznik.prototype.nasluch = function (cel, nazwa, funkcja, opcje) {
    cel.addEventListener(nazwa, funkcja, opcje);
    this.uchwyty.push([cel, nazwa, funkcja, opcje]);
  };

  Wskaznik.prototype.zbuduj = function () {
    var self = this;
    this.kafle = Array.prototype.filter.call(this.tor.children, function (k) { return k.nodeType === 1; });
    var ile = this.kafle.length;
    this.kafle.forEach(function (kafel, i) {
      var kreska = document.createElement('button');
      kreska.type = 'button';
      kreska.className = 'bh-pager__dot';
      kreska.setAttribute('aria-label', self.etykieta.replace('[n]', String(i + 1)).replace('[m]', String(ile)));
      var pasek = document.createElement('span');
      pasek.className = 'bh-pager__bar';
      pasek.setAttribute('aria-hidden', 'true');
      kreska.appendChild(pasek);
      self.nasluch(kreska, 'click', function () {
        var wybor = new CustomEvent('bh:do-kafla', { detail: { indeks: i }, cancelable: true });
        if (!self.tor.dispatchEvent(wybor)) return;
        var api = window.BramoweHomeScroll;
        if (api && api.doElementuToru) api.doElementuToru(self.tor, kafel);
      });
      self.el.appendChild(kreska);
      self.kreski.push(kreska);
    });
  };

  Wskaznik.prototype.podlacz = function () {
    var self = this;
    var zaplanuj = function () {
      if (self.ramka) return;
      self.ramka = window.requestAnimationFrame(function () { self.ramka = 0; self.odswiez(); });
    };
    this.nasluch(this.tor, 'scroll', zaplanuj, { passive: true });
    this.nasluch(this.tor, 'pointermove', zaplanuj, { passive: true });

    this.nasluch(this.tor, 'transitionrun', function () { self.startPetli(); });
    this.nasluch(this.tor, 'transitionend', function () { self.petla = false; zaplanuj(); });
    this.nasluch(this.tor, 'transitioncancel', function () { self.petla = false; zaplanuj(); });
    if (typeof window.MutationObserver === 'function') {
      this.zmiany = new window.MutationObserver(zaplanuj);
      this.zmiany.observe(this.tor, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    if (typeof window.ResizeObserver === 'function') {
      this.obserwator = new window.ResizeObserver(zaplanuj);
      this.obserwator.observe(this.tor);
    }
  };

  Wskaznik.prototype.startPetli = function () {
    var self = this;
    if (this.petla) return;
    this.petla = true;
    var krok = function () {
      if (!self.petla) return;
      self.odswiez();
      window.requestAnimationFrame(krok);
    };
    window.requestAnimationFrame(krok);
  };

  Wskaznik.prototype.okno = function () {
    var przepelnienie = window.getComputedStyle(this.tor).overflowX;
    return przepelnienie === 'auto' || przepelnienie === 'scroll' ? this.tor : this.tor.parentElement;
  };

  Wskaznik.prototype.odswiez = function () {
    if (!this.kafle.length) return;
    var rt = this.okno().getBoundingClientRect();
    var pierwszy = this.kafle[0].getBoundingClientRect();
    var ostatni = this.kafle[this.kafle.length - 1].getBoundingClientRect();
    var przewija = this.kafle.length > 1 && ostatni.right - pierwszy.left > rt.width + 1;
    this.el.classList.toggle('bh-pager--zbedny', !przewija);
    if (!przewija) return;

    var najlepszy = 0;
    var max = -1;
    for (var i = 0; i < this.kafle.length; i += 1) {
      var rk = this.kafle[i].getBoundingClientRect();
      var widoczne = Math.min(rk.right, rt.right) - Math.max(rk.left, rt.left);
      if (widoczne > max + 0.5) { max = widoczne; najlepszy = i; }
    }
    for (var k = 0; k < this.kreski.length; k += 1) {
      if (k === najlepszy) this.kreski[k].setAttribute('aria-current', 'true');
      else this.kreski[k].removeAttribute('aria-current');
    }
  };

  Wskaznik.prototype.rozlacz = function () {
    for (var i = 0; i < this.uchwyty.length; i += 1) {
      var u = this.uchwyty[i];
      u[0].removeEventListener(u[1], u[2], u[3]);
    }
    this.uchwyty = [];
    if (this.obserwator) this.obserwator.disconnect();
    if (this.zmiany) this.zmiany.disconnect();
    this.petla = false;
    if (this.ramka) window.cancelAnimationFrame(this.ramka);
    while (this.el.firstChild) this.el.removeChild(this.el.firstChild);
    this.kreski = [];
  };

  var instancje = new WeakMap();

  function uruchom(zakres) {
    var el = (zakres || document).querySelectorAll('[data-bh-pager]');
    for (var i = 0; i < el.length; i += 1) {
      if (instancje.has(el[i])) continue;
      instancje.set(el[i], new Wskaznik(el[i]));
    }
  }

  function zatrzymaj(zakres) {
    var el = (zakres || document).querySelectorAll('[data-bh-pager]');
    for (var i = 0; i < el.length; i += 1) {
      var w = instancje.get(el[i]);
      if (w) { w.rozlacz(); instancje.delete(el[i]); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { uruchom(); });
  } else {
    uruchom();
  }

  document.addEventListener('shopify:section:load', function (ev) { uruchom(ev.target); });
  document.addEventListener('shopify:section:unload', function (ev) { zatrzymaj(ev.target); });
}());
